module.exports = __webpack_public_path__ + "horizontal.efec37fefb08a512cf58d39c515298a2.png";